export const SOCIAL_LINKS = {
  FACEBOOK: "https://www.facebook.com/share/1AzC7JwYVN/",
  TELEGRAM: "https://t.me/Bunatmoad",
  EMAIL: "mailto:bunat-contact@moad.gov.sy",
};

export const ROUTES = {
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
};